import { render, staticRenderFns } from "./SaveToWorkspaceComplex.vue?vue&type=template&id=b7074182"
import script from "./SaveToWorkspaceComplex.vue?vue&type=script&lang=js"
export * from "./SaveToWorkspaceComplex.vue?vue&type=script&lang=js"
import style0 from "./SaveToWorkspaceComplex.vue?vue&type=style&index=0&id=b7074182&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports